import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import { renderToString } from 'react-dom/server';

import { labelStyle, lgXaxisLabels, responsiveFun } from '../options';
import ApexCharts from 'apexcharts';

import trans from '../../translations.json';
import ReducedData from '../../reducedData.json';
import dict from '../../dictionary';
import { DownloadButton } from '../options';
import { ToolTipClone } from '../toolTipClone/toolTipClone';
import LegandCheckbox from '../legandCheckbox/legandCheckbox';

const colours = ['#D0908C', '#a5cfa0', '#626262'];

class GenderGraph extends Component {
  state = {
    genderNames: [
      trans.CasesByGender.male[this.props.lang],
      trans.CasesByGender.female[this.props.lang],
      trans.CasesByGender.other[this.props.lang],
      trans.CasesByGender.unspecified[this.props.lang],
    ],
    ready: false,
    series: [{}],
    options: {},
    totalCases: undefined,
  };

  componentDidMount() {
    this.init();
  }

  toggle = (name) => {
    ApexCharts.exec('gender', 'toggleSeries', name);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.init();
    }
  }

  init() {
    var cD = Object.values(ReducedData.dataSex);

    const genderNames = this.state.genderNames;
    const lang = this.props.lang;

    const reso = cD.map((item) => {
      return item[dict.resolved];
    });

    const active = cD.map((item) => {
      return item[dict.NotResolved];
    });
    const fatal = cD.map((item) => {
      return item[dict.deaths];
    });
    const total = [];
    for (let i = 0; i < fatal.length; i++) {
      total[i] = reso[i] + active[i] + fatal[i];
    }

    this.setState({
      series: [
        {
          name: trans.CasesByGender.active[this.props.lang],
          data: active,
        },
        {
          name: trans.CasesByGender.resolved[this.props.lang],
          data: reso,
        },
        {
          name: trans.CasesByGender.fatal[this.props.lang],
          data: fatal,
        },
      ],
      stackOptions: {
        legend: {
          show: false,
        },
        tooltip: {
          followCursor: true,
          style: { ...labelStyle },

          custom: function ({
            series,
            seriesIndex,
            dataPointIndex,
            w,
          }) {
            let toolTipData = [
              {
                label: trans.CasesByGender.active[lang],
                value: active[dataPointIndex].toLocaleString(),
                colour: colours[0],
              },
              {
                label: trans.CasesByGender.resolved[lang],
                value: reso[dataPointIndex].toLocaleString(),
                colour: colours[1],
              },
              {
                label: trans.CasesByGender.fatal[lang],
                value: fatal[dataPointIndex].toLocaleString(),
                colour: colours[2],
              },
            ];
            if (w.globals.collapsedSeriesIndices.length === 1) {
              if (w.globals.collapsedSeriesIndices[0] === 0) {
                toolTipData.shift();
              } else if (w.globals.collapsedSeriesIndices[0] === 1) {
                toolTipData.splice(1, 1);
              } else if (w.globals.collapsedSeriesIndices[0]) {
                toolTipData.pop();
              }
            } else if (
              w.globals.collapsedSeriesIndices.length === 2
            ) {
              if (
                w.globals.collapsedSeriesIndices.includes(0) &&
                w.globals.collapsedSeriesIndices.includes(1)
              ) {
                toolTipData.shift();
                toolTipData.shift();
              } else if (
                w.globals.collapsedSeriesIndices.includes(0) &&
                w.globals.collapsedSeriesIndices.includes(2)
              ) {
                toolTipData.shift();
                toolTipData.pop();
              } else if (
                w.globals.collapsedSeriesIndices.includes(1) &&
                w.globals.collapsedSeriesIndices.includes(2)
              ) {
                toolTipData.pop();
                toolTipData.pop();
              }
            }
            return renderToString(
              ToolTipClone(genderNames[dataPointIndex], toolTipData),
            );
          },
        },
        responsive: [
          {
            ...responsiveFun()[0],
            breakpoint: 330,
            options: {
              ...responsiveFun()[0].options,
              chart: {
                animations: {
                  enabled: false,
                  animateGradually: {
                    enabled: false,
                  },
                  dynamicAnimation: {
                    enabled: false,
                  },
                },
                ...responsiveFun()[0].options.chart,
                width: '280px',
              },
              yaxis: {
                title: {
                  text: trans.CasesByGender.sex[this.props.lang],
                },
                labels: {
                  style: { ...labelStyle, fontSize: '10px' },
                  formatter: (value) =>
                    value
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                },
              },
            },
          },
          ...responsiveFun(),
        ].map((item) => {
          item.options.yaxis.title.text =
            trans.CasesByGender.sex[this.props.lang];
          item.options.chart.height = '300px';
          if (item.options.dataLabels) {
            item.options.dataLabels.enabled = true;
            item.options.dataLabels.offsetX = 17;
          }
          return item;
        }),
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          id: 'gender',
          type: 'bar',
          height: 650,
          width: '100%',
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: true,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          // zoom: { enabled: true },
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 25,
          style: { ...labelStyle },
          formatter: function (
            value,
            { seriesIndex, dataPointIndex, w },
          ) {
            let indices = w.config.series.map((item, i) => i);
            indices = indices.filter(
              (i) =>
                !w.globals.collapsedSeriesIndices.includes(i) &&
                w.config.series[i].data[dataPointIndex] > 0,
            );
            if (seriesIndex === indices[indices.length - 1]) {
              return lang === 'fr'
                ? w.globals.stackedSeriesTotals[
                    dataPointIndex
                  ].toLocaleString()
                : w.globals.stackedSeriesTotals[dataPointIndex]
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return '';
          },
        },

        colors: colours,
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '45%',
            dataLabels: {
              position: 'top',
            },
          },
        },
        stroke: {
          width: 2,
          colors: ['#fff'],
        },
        yaxis: {
          title: {
            text: trans.CasesByGender.sex[this.props.lang],
          },
          labels: {
            style: { ...labelStyle },
          },
        },
        xaxis: {
          title: {
            offsetY: 20,
            text: trans.casesTotal.yaxis[this.props.lang],
          },
          categories: [
            trans.CasesByGender.male[this.props.lang],
            trans.CasesByGender.female[this.props.lang],
            trans.CasesByGender.other[this.props.lang],
            trans.CasesByGender.unspecified[this.props.lang],
          ],
          labels: {
            ...lgXaxisLabels,
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
      },
    });

    this.setState({ ready: true });
  }

  render() {
    return (
      this.state.ready && (
        <div id="genderGraph">
          <LegandCheckbox
            series={this.state.series}
            colours={colours}
            toggle={this.toggle}
          />
          <ReactApexChart
            options={this.state.stackOptions}
            series={this.state.series}
            type="bar"
            height="400px"
            aria-hidden="true"
          />
        </div>
      )
    );
  }
}
export default GenderGraph;
